/* eslint-disable no-undef */
export default {
	name: "orders-collection-dashboard",
	data() {
		return {
			recentOrders: [],
			orderStatuses: [],
			report:{
				startDate: null,
				endDate: null
			},
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			initialiseDatePicker: true,
			initialiseDatePickerEndDate: true,
			collectionOrderHeadings: [
				{
					text: "Order #",
					field: "orderId"
				},
				{
					text: "Customer",
					field: "registeredCompanyName"
				},
				{
					text: "Depot",
					field: "depot"
				},
				{
					text: "Order Type",
					field: "orderType"
				},
				{
					text: "Order Date",
					field: "insertedOn"
				},
				{
					text: "Vehicle",
					field: "vehicle"
				},
				{
					text: "Fleet Number",
					field: "fleetNumber"
				},
				{
					text: "Manifest Number",
					field: "manifestNumber"
				},
				{
					text: "total",
					field: "totalAsString"
				},
				{
					text: "Status",
					field: "description"
				}
			],
			actionKeys:{
				viewOrder: "viewOrder"
			},
			filterStateChanged: false,
			filter:{
				fromDateCreated: null,
				toDateCreated: null,
				customerSearchQuery: null,
				activeOrInactiveItems: 1,
				orderTypeId: 1,
				companyId: null,
				orderStatusId: null
			},
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
			hasLoaded: false,
			loading: false,
			errorMessage: null
		};
	},
	methods: {
		getRecentCollectionOrders(){
			this.loading = true;
			let request = {
				searchQuery: this.filter.customerSearchQuery,
				orderStatusId: this.filter.orderStatusId,
				fromDateCreated: this.filter.fromDateCreated,
				toDateCreated: this.filter.toDateCreated,
			};
			orderService.getRecentCollectionOrders(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.recentOrders = successResponse.data.result;
						for(let i = 0; i < this.recentOrders.length; i++){
							this.recentOrders[i].totalAsString = currencyHelper.numberToCurrency(this.recentOrders[i].totalAmount);
							this.recentOrders[i].actions = [
								{
									name: "View Order",
									key: this.actionKeys.viewOrder,
									elementId: "btnDeliveryOrdersDashboardViewOrder"
								}
							];
						}
						this.recentOrders = dataTableHelper.castFieldValues(this.recentOrders);
						this.hasLoaded = true;
						this.filterStateChanged = false;
						//permissionsHelper.setControlsBasedOnPermissions();
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getOrderStatuses(){
			this.orderStatuses = orderService.getCollectionOrderStatues();
			this.orderStatuses = $.map(this.orderStatuses,
				function (obj) {
					obj.id = obj.id || obj.orderStatusId;
					obj.text = obj.text || obj.description;
					return obj;
				});
			this.orderStatuses.unshift({
				id: 0,
				text: "All"
			});
			this.filter.orderStatusId = 0;
			this.getRecentCollectionOrders();
		},
		onFilterSearchClicked(){
			this.getRecentCollectionOrders();
		},
		onOrderStatusSelect(orderStatus){
			if(orderStatus.id !== this.filter.orderStatusId){
				this.filter.orderStatusId = orderStatus.id;
				this.filterStateChanged = true;
			}
			//this.filter.orderStatusId = orderStatus.id;
			console.log("order status change");
		},
		onDateFilterClearClick(){
			this.filter.toDateCreated = null;
			this.filter.fromDateCreated = null;
			this.filterStateChanged = true;
		},
		onFromDateCreatedSelect(date){
			this.filter.fromDateCreated = date;
			this.filterStateChanged = true;
		},
		onToDateCreatedSelect(date){
			this.filter.toDateCreated = date;
			this.filterStateChanged = true;
		},
		onOrderActionClicked(actionAndData){
			console.log("actionAndData", actionAndData);
			switch(actionAndData.action) {
				case this.actionKeys.viewOrder:
					this.$router.push("/orders/collection/viewOrder/" + actionAndData.data.orderId + "/" + actionAndData.data.orderCollectionId);
					break;
			}
		},
		onFromReportDateSelect(date){
			this.report.startDate = date;
			this.initialiseDatePicker = false;
		},
		onToReportDateSelect(date){
			this.report.endDate = date;
			this.initialiseDatePickerEndDate = false;
		},
		checkReportCollectionVolumeDispensed(){
			console.log("checkReportCollectionVolumeDispensed");
			this.errorMessage = null;
			if(this.report.startDate === null || this.report.endDate === null){
				this.errorMessage = "Please select a date range";
				return;
			}
			this.loading = true;
			let request = {
				startDate: this.report.startDate,
				endDate: this.report.endDate
			};
			orderService.checkReportCollectionVolumeDispensed(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					this.loading = false;
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						if(successResponse.data.hasError){
							this.errorMessage = successResponse.data.message;
						}
						else{
							this.downloadReportCollectionVolumeDispensed();
						}
						this.loading = false;
					}
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		downloadReportCollectionVolumeDispensed(){
			this.errorMessage = null;
			if(this.report.startDate === null || this.report.endDate === null){
				this.errorMessage = "Please select a date range";
				return;
			}
			this.loading = true;
			let request = {
				startDate: this.report.startDate,
				endDate: this.report.endDate
			};
			orderService.downloadReportCollectionVolumeDispensed(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					const url = window.URL.createObjectURL(new Blob([successResponse.data]));
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', "CollectionVolumeDispensedReport.xlsx");
					document.body.appendChild(link);
					link.click();
					this.loading = false;
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		checkReportDeliveryVarianceReport(){
			this.errorMessage = null;
			if(this.report.startDate === null || this.report.endDate === null){
				this.errorMessage = "Please select a date range";
				return;
			}
			this.loading = true;
			let request = {
				startDate: this.report.startDate,
				endDate: this.report.endDate
			};
			orderService.checkReportDeliveryVarianceReport(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						if(successResponse.data.hasError){
							this.errorMessage = successResponse.data.message;
						}
						else{
							this.downloadReportDeliveryVarianceReport();
						}
						this.loading = false;
					}
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		downloadReportDeliveryVarianceReport(){
			this.errorMessage = null;
			if(this.report.startDate === null || this.report.endDate === null){
				this.errorMessage = "Please select a date range";
				return;
			}
			this.loading = true;
			let request = {
				startDate: this.report.startDate,
				endDate: this.report.endDate
			};
			orderService.downloadReportDeliveryVarianceReport(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					const url = window.URL.createObjectURL(new Blob([successResponse.data]));
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', "DeliveryVarianceReport.xlsx");
					document.body.appendChild(link);
					link.click();
					this.loading = false;
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		}
	},
	mounted: function () {
		this.filter.orderStatusId = orderHelper.orderStatus.readyForCollection;
		this.getOrderStatuses();
		storeState.setPageTitleAction("Recent Orders - Collection");
		breadcrumbsStoreState.setRootBreadcrumb(this.$route.path, "Recent Orders - Collection");
	}
};